module.exports = __webpack_public_path__ + "img/5.46a32b8d.svg";